export default "__VITE_ASSET__8e271d17__"